{getHostname} = require('../../../../utils')


module.exports = ($scope, $uibModal, workflowStepConfig, Api) ->
  $scope.getHostname = getHostname

  $scope.stepConfig = workflowStepConfig

  $scope.getStarredDocs = () ->
    $scope.stepStarredDocs
